import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@solarwindscloud/nighthawk-ui';
import styles from './LinkedButton.module.scss';
import RouterLink from '../RouterLink/RouterLink';
import { redirectTo } from '../../utils/utils';

const LinkedButton = props => {
  const { link, label, external } = props;
  if (external) {
    return <ExternalLinkedButton {...props} />;
  }
  return (
    <RouterLink to={link}>
      <Button
        type="button"
        secondary
        data-test-linked-button
        floated="right"
        data-test-id="linked-button"
        id={styles.linkedButtonColor}
      >
        {label}
      </Button>
    </RouterLink>
  );
};

const ExternalLinkedButton = props => {
  const { link, label } = props;
  return (
    <Button
      type="button"
      secondary
      data-test-linked-button
      floated="right"
      data-test-id="linked-button"
      id={styles.linkedButtonColor}
      onClick={() => redirectTo(link)}
    >
      {label}
    </Button>
  );
};

LinkedButton.propTypes = {
  link: PropTypes.string,
  label: PropTypes.string,
  external: PropTypes.bool,
};
LinkedButton.displayName = 'LinkedButton';

export default LinkedButton;
